import "./form-reward.scss";
import { useFormContext } from "react-hook-form";
import { RewardFormSchema } from "@factory/form/form.rule";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";

type InputFormSchema = RewardFormSchema;
export function FormReward() {
  const { control } = useFormContext<RewardFormSchema>();
  return (
    <div id="FormReward" className="reward">
      {/* <InputControl<InputFormSchema>
        control={control}
        name="tenant"
        label="Tenant"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter tenant"
      /> */}
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isActive"
        label="Is Active"
        containerClassName="pb-2"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isPoints"
        label="Is Points"
        containerClassName="pb-2"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isStamp"
        label="Is Stamp"
        containerClassName="pb-2"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="denominationPoints"
        label="Denomination Points"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter denominationPoints"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="points"
        label="Points"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter points"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="denominationStamp"
        label="Denomination Stamp"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter denominationStamp"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="stamp"
        label="Stamp"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter stamp"
      />
    </div>
  );
}

export default FormReward;
